module.exports = __webpack_public_path__ + "static/media/fixed_voice_dash_reschedule.d1200f2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_dash_reschedule.svg
// module id = 3196
// module chunks = 0